import React, { useMemo } from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

export interface ITierItem {
    label: string;
    color: 'primary' | 'neutral';
}

export const TierItem: React.FC<ITierItem> = (props) => {
    const { label, color } = props;

    const colorStyles = useMemo(() => {
        switch (color) {
            case 'primary':
                return 'bg-primary';
            default:
                return 'bg-neutral-500/50 backdrop-blur-2xl';
        }
    }, [color]);

    return (
        <figure className="relative flex w-full flex-row items-center gap-4 ">
            <span
                className={`flex h-8 w-8 items-center justify-center rounded-full ${colorStyles}`}
            >
                <CheckIcon className="h-6 text-white" />
            </span>
            <span className="text-xl font-semibold text-neutral-100">{label}</span>
        </figure>
    );
};
